import getApi from '../../../api'
import { UiQuoteline } from '../../../components/ccam/QuoteLineForm/QuoteLineForm.model'
import { serializeQuoteLine } from './mapper/quoteLines.mapper'

export const updateQuoteLine = (quoteLineId: string, quoteLinePayload: UiQuoteline) =>
  getApi().put(`/quote_lines/${quoteLineId}`, serializeQuoteLine(quoteLinePayload))
